import { Component } from 'react';


class Service extends Component {


postServiceCall(url, params) {
      if ((typeof params).toLowerCase() === "string") {
        params = JSON.parse(params);
      }
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
           "Authorization":global.ftk
        }
      }).then(res => res.json());
    // } else {
    //   this.hideLoader();
    //   this.showAlert("Please Check Internet Connection!!!");
    //   return false;
    // }
  }
    postServiceCallUploadFile(url, params) {
    // if (navigator.onLine) {
      if ((typeof params).toLowerCase() === "string") {
        params = JSON.parse(params);
      }
      return fetch(url, {
        method: 'POST',
        headers: {
           "Authorization":global.ftk,
        },
        body: params
      }).then(res => res.json());
    // } else {
    //   this.hideLoader();
    //   this.showAlert("Please Check Internet Connection!!!");
    //   return false;
    // }
  }
  postServiceCallLogout(url, params) {

    if (navigator.onLine) {
      if ((typeof params).toLowerCase() === "string") {
        params = JSON.parse(params);
      }
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'authtoken': global.ftk,
          'Content-Type': 'application/json',
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }
 postServiceCallFC(url, params) {
    if (navigator.onLine) {
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
          "authtoken":global.ftk,
        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }


  


getServiceCall(url){
    if (navigator.onLine) {
      return fetch(url).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  postFileServiceCall (url, file, file_name) {
    if (navigator.onLine) {
      const data = new FormData()
      data.append('file', file, file_name)
      return fetch(url, {
        method: 'POST',
        body: data,
        headers: {
          'ftk': global.ftk,
          'uid': global.uID,
          'access-token': global.accessToken,
          'user-agent': global.userAgent,
          'isdesktop': global.isdesktop,
          "authtoken":global.ftk,


        }
      }).then(res => res.json());
    } else {
      this.hideLoader();
      this.showAlert("Please Check Internet Connection!!!");
      return false;
    }
  }

  jsontracker(val) {
    // var t = {
    //   appurl: val
    // };
    if (window.MobileBridge) {
      window.MobileBridge.changeNavbarBackground(val);
      return true;
    } else if (/iphone|ipod|ipad/.test(window.navigator.userAgent.toLowerCase())) {
  
      window.webkit.messageHandlers.cookieStatus.postMessage(val);

      return true;
    } else {
      return false;
    }
  }

  replaceSymbols (val) {
    if (val) {
      var mainurl = val.trim().toLowerCase();
      // if (__isBrowser__ && window.location.href.includes('coloring-pages-printables')) {
      //   mainurl = mainurl.replace(/&/g, "and");
      // }
      mainurl = mainurl.replace(/[\W_]+/g, "-");
      mainurl = mainurl.replace("---", "-");
      mainurl = mainurl.replace("--", "-");
      if (mainurl.charAt(0) === '-') {
        mainurl = mainurl.substr(1);
      }
      return mainurl;
    } else {
      return val;
    }
  }



  showTracking(){
    if (document.getElementById('hidden_tracking')) {
      document.getElementById('hidden_tracking').style.display = "block";
    }
  }

hideTracking()  {
    if (document.getElementById('hidden_tracking')) {
      document.getElementById('hidden_tracking').style.display = "none";
    }
  }

  showLoader () {
    document.getElementsByClassName('loader-overlay')[0] && (document.getElementsByClassName('loader-overlay')[0].style.display = "block");
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }

  hideLoader () {
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementsByClassName('loader-overlay')[0] && (document.getElementsByClassName('loader-overlay')[0].style.display = "none");
  }

   showAlert (msg){ 
 document.getElementsByClassName('alertmsg')[0] && (document.getElementsByClassName('alertmsg')[0].innerHTML = msg);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByClassName('alertMsg-overlay')[0] && (document.getElementsByClassName('alertMsg-overlay')[0].style.display = "block");
    setTimeout(function () {
      document.getElementsByClassName('alertMsg-overlay')[0] && (document.getElementsByClassName('alertMsg-overlay')[0].style.display = "none");
      document.getElementsByTagName('body')[0].style.overflow = 'visible';
      document.getElementsByClassName('alertmsg')[0] && (document.getElementsByClassName('alertmsg')[0].innerHTML = "");
    }, 2000);
  }

  sticky_div() {
    if (document.getElementsByClassName('registrationRight')[0]) {
      var scrollTop = window.pageYOffset;
      var div_top = document.getElementsByClassName('registrationRight')[0].offsetTop + 164;
      var left_height = document.getElementsByClassName('main-container')[0].offsetHeight;
      var right_height = document.getElementsByClassName('rightside')[0].offsetHeight;
      var footerEle = document.getElementsByClassName('footer_fclogo_text_container')[0];
      if (this.isScrolledIntoView(footerEle)) {
        if (scrollTop > div_top && left_height > right_height) {
          document.getElementsByClassName('rightside')[0].classList.remove('stick');
          document.getElementsByClassName('rightside')[0].classList.add('btmfixed');
        }
      } else {
        document.getElementsByClassName('rightside')[0].classList.remove('btmfixed');
        if (scrollTop > div_top && left_height > right_height) {
          document.getElementsByClassName('rightside')[0].classList.add('stick');
        } else {
          document.getElementsByClassName('rightside')[0].classList.remove('stick');
        }
      }
    }
  }

 isScrolledIntoView(elem) {
    var docViewTop = window.pageYOffset;
    var docViewBottom = docViewTop + window.outerHeight;
    var elemTop = elem ? elem.offsetTop : 0;
    var elemBottom = elemTop;
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

 loadImages(){
    var imgDefer = document.getElementsByTagName('img');
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].hasAttribute('data-src')) {
        var newsrc = imgDefer[i].getAttribute('data-src');
        imgDefer[i].setAttribute('src', newsrc);
        imgDefer[i].removeAttribute("data-src");
        imgDefer[i].onload = function () {
          this.classList.remove('loadingImg');
        };
      }
    }
  }

  // lazyLoadImages() {
  //   var docElem = document.documentElement;
  //   window.lazySizesConfig = window.lazySizesConfig || {};
  //   window.lazySizesConfig.loadMode = 1;
  //   //set expand to a higher value on larger displays
  //   window.lazySizesConfig.expand = Math.max(Math.min(docElem.clientWidth, docElem.clientHeight, 1222) - 1, 359);
  //   window.lazySizesConfig.expFactor = lazySizesConfig.expand < 380 ? 3 : 2;
  // }
slideSlider (id, scrollVal, scrollTime) {
    this.scrollHorizontal(document.getElementById(id), scrollVal, scrollTime);
  }

 scrollHorizontal(element, change, duration) {
    var start = element.scrollLeft,
      currentTime = 0,
      increment = 20;

    var easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    var animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  intToString (value) {
    if (!value) {
      return '0';
    } else if (isNaN(value) || parseInt(value) <= 999) {
      return value;
    } else {
      var suffixes = ["", "K", "M", "B", "T"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue = parseFloat((suffixNum !== 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));
      var shortNum = shortValue;
      if (shortValue % 1 !== 0) {
        shortNum = shortValue.toFixed(1);
      }
      return shortNum + suffixes[suffixNum];
    }
  }


   secondsToMS (s) {
    let m = Math.floor(s / 60);
    s -= m * 60;
    s = Math.floor(s);
    return (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s)
  }



  closeUserlist (event) {
    if (event.target.classList.contains('followers-overlay') || event.target.classList.contains('closeButton')) {
      this.closeUserListPopup();
    }
  }

 closeUserListPopup () {
    document.getElementsByClassName('followers-overlay')[0].style.display = 'none';
    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = '';
    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = '';
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
  }



  

 onKeyPressDate (event) {
    event.returnValue = false;
    if (event.preventDefault) event.preventDefault();
  }

  onFocusDate (event)  {
    var val;
    if (event.target.value && event.target.value !== '') {
      val = new Date(event.target.value);
      var y = val.getFullYear();
      var m = val.getMonth() + 1;
      var d = val.getDate();
      m = m > 9 ? m : "0" + m;
      d = d > 9 ? d : "0" + d;
      var finalVal = y + '-' + m + '-' + d;
      event.target.value = finalVal;
    }
    event.target.type = "date";
    event.target.readOnly = false;
    if (event.preventDefault) event.preventDefault();
    event.target.focus();
  }

  onBlurDate(event) {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    event.target.type = "text";
    event.target.readOnly = true;
    if (event.target.value && event.target.value !== '') {
      let date = new Date(event.target.value);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      event.target.value = day + " " + months[date.getMonth()] + " " + date.getFullYear();
    }
  }

 isMobile () {
    if (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      return true;
    } else {
      return false;
    }
  }

  disableCutCopyPaste(id) {
    let ele = document.getElementById(id);
    if (ele) {
      ele.onpaste = e => {
        e.preventDefault();
        return false;
      };
      ele.oncopy = e => {
        e.preventDefault();
        return false;
      };
      ele.oncut = e => {
        e.preventDefault();
        return false;
      };
    }
  }

  scrollCenterKeySlider() {
    let elem = document.querySelector("#keySlider ul li.active");
    var activeWidth = elem.offsetWidth / 2;
    var pos = elem.offsetLeft + activeWidth;
    var elpos = document.querySelector("#keySlider").scrollLeft;
    var elW = document.querySelector("#keySlider").offsetWidth;
    var scrolllft = pos + elpos - elW / 2;
    document.querySelector("#keySlider").scrollLeft = scrolllft - elpos;
  }
}

export default Service;
